import { useState } from 'react';
import { useMedia } from '../lib/useMedia.js';
import { nav, navigate } from './nav.js';
import { UI, setUi, setDark, useApp } from '../store/ui.js';
import { curKey, keyAdd, periodLabel, periodShort } from '../domain/periods.js';
import { Icon } from '../components/Icon.jsx';
import { logout } from '../store/actions.js';
import { confirmDialog } from '../components/ui.jsx';
import { openScan } from '../features/add/AddPage.jsx';
import { InstallNavItem } from '../components/Install.jsx';

export const NAV = [
  { k: 'Dash', ico: 'home', label: 'בית' },
  { k: 'Tx', ico: 'list', label: 'פעולות' },
  { k: 'Flow', ico: 'flow', label: 'תזרים' },
  { k: 'Year', ico: 'chart', label: 'מבט שנתי' },
  { k: 'Goals', ico: 'piggy', label: 'חיסכון' },
  { k: 'Set', ico: 'settings', label: 'הגדרות' },
];
const TITLES = { Dash: 'סקירה', Tx: 'פעולות', Add: 'הוספה וסריקה', Flow: 'תזרים', Year: 'מבט שנתי', Goals: 'חיסכון', Set: 'הגדרות' };
// מסכים שהתוכן שלהם תלוי בתקופה המוצגת
const PERIOD_PAGES = ['Dash', 'Tx', 'Set'];

export { useMedia };

export function Sidebar() {
  useApp();
  const email = localStorage.getItem('sb_email') || '';
  async function out() { if (await confirmDialog({ title: 'התנתקות', body: 'להתנתק מהחשבון?', okLabel: 'התנתק', danger: true })) logout(); }
  return (
    <aside className="side">
      <div className="brand"><span className="brand-mark"><Icon name="wallet" size={19} /></span>תקציב משפחתי</div>
      <button className="side-add" onClick={() => navigate('Add')}><Icon name="plus" size={18} />הוספה או סריקה</button>
      <nav>
        {NAV.map((n) => (
          <button key={n.k} className={'nav-item' + (nav.page === n.k ? ' on' : '')} onClick={() => navigate(n.k)}>
            <Icon name={n.ico} />{n.label}
          </button>
        ))}
      </nav>
      <div className="side-foot">
        <button className="nav-item" onClick={() => setDark(!UI.dark)}><Icon name={UI.dark ? 'sun' : 'moon'} />{UI.dark ? 'מצב בהיר' : 'מצב כהה'}</button>
        <button className="nav-item" onClick={out}><Icon name="logout" />התנתקות</button>
        {email && <div className="side-user" title={email}>{email}</div>}
      </div>
    </aside>
  );
}

export function PeriodSwitcher() {
  useApp();
  const move = (n) => setUi({ viewKey: keyAdd(UI.viewKey, n) });
  const isCur = UI.viewKey === curKey();
  return (
    <div className="row" style={{ gap: 6 }}>
      {!isCur && <button className="period-now" onClick={() => setUi({ viewKey: curKey() })}>לתקופה הנוכחית</button>}
      <div className="period-sw" title={periodLabel(UI.viewKey)}>
        <button onClick={() => move(-1)} aria-label="תקופה קודמת"><Icon name="chevR" size={18} /></button>
        <span className="desktop-only">{periodLabel(UI.viewKey)}</span>
        <span className="mobile-only">{periodShort(UI.viewKey)}</span>
        <button onClick={() => move(1)} aria-label="תקופה הבאה"><Icon name="chevL" size={18} /></button>
      </div>
    </div>
  );
}

export function TopBar() {
  useApp();
  const p = nav.page;
  return (
    <header className="topbar">
      <div className="topbar-brand">
        <span style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--accent)', color: '#fff', display: 'grid', placeItems: 'center' }}><Icon name="wallet" size={17} /></span>
        <span className="ellipsis">{TITLES[p]}</span>
      </div>
      <div className="topbar-title desktop-only">{TITLES[p]}</div>
      <div className="topbar-actions">
        {PERIOD_PAGES.includes(p) && <PeriodSwitcher />}
        {p !== 'Add' && <button className="ubtn ubtn-outline ubtn-sm desktop-only" onClick={openScan}><Icon name="scan" size={17} />סריקת דוח</button>}
        <button className="icon-btn mobile-only" onClick={() => setDark(!UI.dark)} aria-label="מצב כהה"><Icon name={UI.dark ? 'sun' : 'moon'} /></button>
      </div>
    </header>
  );
}

export function TabBar() {
  useApp();
  const [menu, setMenu] = useState(false);
  const p = nav.page;
  const tab = (k, ico, label) => (
    <button key={k} className={'tab' + (p === k ? ' on' : '')} onClick={() => navigate(k)}><Icon name={ico} size={22} />{label}</button>
  );
  return (
    <>
      <nav className="tabbar">
        {tab('Dash', 'home', 'בית')}
        {tab('Tx', 'list', 'פעולות')}
        <button className={'tab tab-add' + (p === 'Add' ? ' on' : '')} onClick={() => navigate('Add')} aria-label="הוספה"><span className="fab"><Icon name="plus" size={24} stroke={2.2} /></span></button>
        {tab('Flow', 'flow', 'תזרים')}
        <button className={'tab' + (p === 'Goals' || p === 'Set' || p === 'Year' ? ' on' : '')} onClick={() => setMenu(true)}><Icon name="more" size={22} />עוד</button>
      </nav>
      {menu && (
        <>
          <div className="drawer-ov" onClick={() => setMenu(false)} />
          <div className="drawer">
            <div className="row-b" style={{ padding: '18px 16px 10px' }}>
              <div className="row" style={{ fontWeight: 800 }}><span style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--accent)', color: '#fff', display: 'grid', placeItems: 'center' }}><Icon name="wallet" size={17} /></span>תקציב משפחתי</div>
              <button className="sheet-x" onClick={() => setMenu(false)} aria-label="סגור"><Icon name="x" size={16} /></button>
            </div>
            <div style={{ padding: '4px 10px' }}>
              {NAV.map((n) => (
                <button key={n.k} className={'nav-item' + (p === n.k ? ' on' : '')} onClick={() => { setMenu(false); navigate(n.k); }}><Icon name={n.ico} />{n.label}</button>
              ))}
              <div className="divider" />
              <button className="nav-item" onClick={() => { setMenu(false); openScan(); }}><Icon name="scan" />סריקת דוח</button>
              <InstallNavItem onDone={() => setMenu(false)} />
            </div>
          </div>
        </>
      )}
    </>
  );
}
